import request from '@/utils/request'
const BASE_URL = '/RpPayDoc'

//付款单
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  review(id) {
    return request({
      url: BASE_URL + '/Review',
      method: 'get',
      params: { id }
    })
  },
  back(id) {
    return request({
      url: BASE_URL + '/Back',
      method: 'get',
      params: { id }
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  clear(id) {
    return request({
      url: BASE_URL + '/Clear',
      method: 'get',
      params: { id }
    })
  },
  //获取列表 应付对账/供应商对账
  getListChkPay(data) {
    return request({
      url: BASE_URL + '/GetListChkPay',
      method: 'post',
      data
    })
  },
  //获取列表 应付明细账
  getListDetailPay(data) {
    return request({
      url: BASE_URL + '/GetListDetailPay',
      method: 'post',
      data
    })
  },
  //获取列表 应付总账 (Kind = 《空字符串''》/普通应付/预付/其它应付)
  getRpPayPaySum(data){
    return request({
      url: BASE_URL + '/GetRpPayPaySum',
      method: 'post',
      data
    })
  },
  alreadyPayDocList(data){
    return request({
      url: BASE_URL + '/VRpAlreadyPayDocList',
      method: 'post',
      data
    })
  },
}